import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Utility } from '../../../../common/utility';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { DialogService } from '../../../../shared/services/dialog.service';
import { PatientInformationCopyService } from './patient-infomation-copy.service';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';



@Component({
  selector: 'patient-information-copy',
  templateUrl: 'patient-infomation-copy.component.html',
  providers: [PatientInformationCopyService, DatePipe]
})

export class PatientInformationCopyComponent implements OnInit {
  @ViewChild('patientinformationcopytext') patientInformationCopyText: ElementRef;
  public patientInformationCopy = "";

  public patientName = "";
  public isShowCopyOnly = false;
  constructor(public utility: Utility,
    private datePipe: DatePipe,
    private patientInformationCopyService: PatientInformationCopyService,
    public dialogService: DialogService,
    public dialogRef: MdDialogRef<PatientInformationCopyComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    private http: HttpClient) { }

  ngOnInit() {
    this.getPatientDetail();
  }

  getPatientDetail() {
    this.patientInformationCopyService.getPatientDetail(this.data.patientId).subscribe(
      (result) => {
        if (result) {
          const patient = result.json();
          this.patientName = `${patient.titleId}${patient.firstName}${patient.middleName}${patient.surName}`
          if (this.data.copyStyle === 4) {
            this.isShowCopyOnly = true;

            this.patientInformationCopy = `${this.datePipe.transform(new Date(), 'dd-MMM-yyyy @ HH.mm')}hrs<br><br>`
              + `<h5><strong>${patient.titleId} ${patient.firstName} ${patient.middleName == null || patient.middleName == '' ? '' : ` ${patient.middleName} `}${patient.surName}</strong></h5>`
              + `${patient.address1}, ${patient.address2},<br>`
              + `${patient.address3 == null || patient.address3 == '' ? '' : `${patient.address3}, `}${patient.postCode == null || patient.postCode == '' ? '' : `${patient.postCode}, `}${patient.countryName}<br><br>`
              + `Date of Birth: ${this.datePipe.transform(patient.dateOfBirth, 'dd-MMM-yyyy')}<br>`
              + `Country of Birth: ${patient.countryOfBirthName}<br>`
              + `${patient.passportOrIdNumber == null || patient.passportOrIdNumber == '' ? '' : `Passport / ID Number: ${patient.passportOrIdNumber}<br>`}`
              + `TMB Reference: ${patient.patientREF}<br>`
              + `Sex: ${patient.sexName}<br>`

            return;
          }
          let address = "";
          let countryOfBirth = "";
          let passportID = "";
          let remainInformation = "";
          let baseCopy = `${this.datePipe.transform(new Date(), 'dd-MMM-yyyy')}\n`
            + `${patient.titleId} ${patient.firstName} ${patient.middleName == null || patient.middleName == '' ? '' : `${patient.middleName} `}${patient.surName}\n`
            + `{0}`
            + `Date of Birth: ${this.datePipe.transform(patient.dateOfBirth, 'dd-MMM-yyyy')}\n`
            + `{1}`
            + `TMB Reference: ${patient.patientREF}\n`
            + `{2}`
            + `Sex: ${patient.sexName}\n`
            + `{3}`
          if (this.data.copyStyle === 1) {
            address = `${patient.address1}, ${patient.address2}\n${patient.address3 == null || patient.address3 == '' ? '' : `${patient.address3}, `}${patient.postCode == null || patient.postCode == '' ? '' : `${patient.postCode}, `}${patient.countryName}\n`;
            remainInformation = `${patient.email == null || patient.email == '' ? '' : `Email: ${patient.email}\n`}`
              + `Country of Birth: ${patient.countryOfBirthName}\n`
              + `${patient.homePhone == null || patient.homePhone == '' ? '' : `Home Phone:  ${patient.homePhone}\n`}`
              + `${patient.workPhone == null || patient.workPhone == '' ? '' : `Work Phone:  ${patient.workPhone}\n`}`
              + `${patient.mobilePhone == null || patient.mobilePhone == '' ? '' : `Mobile Phone:  ${patient.mobilePhone}\n`}`
              + `Occupation: ${patient.occupationName}`;
            passportID = `${patient.passportOrIdNumber == null || patient.passportOrIdNumber == '' ? '' : `Passport / ID Number: ${patient.passportOrIdNumber}\n`}`
          } else if (this.data.copyStyle == 3) {
            address = `${patient.address1}, ${patient.address2}\n${patient.address3 == null || patient.address3 == '' ? '' : `${patient.address3}, `}${patient.postCode == null || patient.postCode == '' ? '' : `${patient.postCode}, `}${patient.countryName}\n`;
            countryOfBirth = `Country of Birth: ${patient.countryOfBirthName}\n`;
          }
          this.patientInformationCopy = Utility.stringFormat(baseCopy, [address, countryOfBirth, passportID, remainInformation])
        }
      }
    );
  }

  copyToClipBoard() {
    if (this.data.copyStyle === 4) {

      var containerid = 'patientInformationCopy4';
      var r = document.createRange();
      r.selectNode(document.getElementById(containerid));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(r);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      this.dialogRef.close();
    }
    else if (this.patientInformationCopyText) {
      this.patientInformationCopyText.nativeElement.select();
      document.execCommand("copy");
      this.patientInformationCopyText.nativeElement.setSelectionRange(0, 0);
      this.dialogRef.close();
    }
  }

  print() {
    const value = this.patientInformationCopy.split('\n').join('<br>');
    var newTab = window.open('', 'Print-Window');
    newTab.document.open();
    newTab.document.write('<html><body onload="window.print()">' + value + '</body></html>');
    newTab.document.close();
    setTimeout(function () { newTab.close(); }, 10);
  }

  export() {
    this.patientInformationCopyService.export(this.data.patientId, this.data.copyStyle).subscribe(
      (result) => {
        saveAs(result._body, `${this.patientName}_${this.datePipe.transform(new Date(), 'ddMMMyyyy')}.csv`, {
          type: 'text/csv;charset=utf-8'
        });
        this.dialogRef.close();
      }
    );
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/patient-infomation-copy/patient-infomation-copy.component.ts